<div class="wrap">



  <div class="title">
    <h3>Liste de mes stagiaires</h3>

    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher un stagiaire ..."
          (input)="applyFilter($event.target.value)" formControlName="keyword">
      </form>

      <fa-icon [icon]=" valueInput? getFaIcon('faTimes'): getFaIcon('faSearch')" (click)="valueInput ? resetSearch(): ''"></fa-icon>
    </div>

    <div class="add_search_trainee_table_desktop">
      <div class="add_trainee" (click)="openDialogAddOrEditTrainee('add')">
        <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
        <span>Ajouter un stagiaire</span>
      </div>
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un stagiaire ..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">
        </form>

        <fa-icon [icon]=" valueInput? getFaIcon('faTimes'): getFaIcon('faSearch')" (click)="valueInput ? resetSearch(): ''"></fa-icon>

      </div>
    </div>

  </div>

  <div class="my_trainees_mobile">
    <form [formGroup]="traineeMobilForm">
      <mat-form-field appearance="outline">
        <mat-label>Mes stagiaires</mat-label>
        <mat-select formControlName="trainee">
          <mat-option  value="no_value" *ngIf="!traineeFiltered?.length && valueInput">
            Il n'y aucun résultat
          </mat-option>
          <mat-option *ngFor="let t of traineeFiltered?.length && valueInput? traineeFiltered : trainees" [value]="t">
            {{t.traineeLastName}} {{t.traineeFirstName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <fa-icon class="add_trainee_mobile" (click)="openDialogAddOrEditTrainee('add')" [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>

    </form>

    <app-trainee-overview *ngIf="traineeFiltered?.length && valueInput || trainees && !valueInput" [trainee]="traineeOverView" (isUpdate)="updateTrainee($event)" ></app-trainee-overview>
  </div>

  <div class="my_trainees_desktop">

    <div class="table">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

        <ng-container matColumnDef="lastname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="discountName" class="cell_club">Nom</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.traineeLastName}} </td>
        </ng-container>

        <ng-container matColumnDef="firstname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_club">Prénom</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.traineeFirstName}} </td>
        </ng-container>

        <ng-container matColumnDef="emergencyPhoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="emergencyPhoneNumber" class="cell_club">N° de téléphone en cas d'urgence</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element?.emergencyPhoneNumber | replace}} </td>
        </ng-container>


        <ng-container matColumnDef="overview">
          <th mat-header-cell *matHeaderCellDef class="cell_action">Aperçu</th>
          <td mat-cell *matCellDef="let element" class="cell_action">
            <fa-icon [icon]="getFaIcon('faImage')" (click)="changePreview(element)" appChangeColorTheme attribute="color"></fa-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>

      </table>

      <div class="no_result" *ngIf="!dataSource?.data?.length || !dataSource?.filteredData?.length">
        <p>Il n'y a pas de résultat</p>
      </div>

      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
    </div>

    <app-trainee-overview [trainee]="traineeOverView" (isUpdate)="updateTrainee($event)"></app-trainee-overview>

  </div>
</div>
